import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#FAEDE6] border-t border-[#B78782]/25 pt-16 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <p className="font-serif-display text-[#4A3737] text-3xl md:text-4xl font-light leading-tight">
              Amber's Mobile Beauty
            </p>
            <p className="mt-2 font-script text-[#B78782] text-2xl">
              Beauty that comes to you.
            </p>
          </div>

          <div className="md:text-right">
            <p className="text-[11px] tracking-[0.32em] uppercase text-[#4A3737]/70">
              Luxury Mobile Beauty Services
            </p>
            <p className="mt-1 text-[11px] tracking-[0.32em] uppercase text-[#4A3737]/70">
              In the Comfort of Your Home · Auckland, NZ
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#B78782]/20 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] tracking-[0.24em] uppercase text-[#4A3737]/60">
          <p>© {new Date().getFullYear()} Amber Rufer · Mobile Beauty Specialist</p>
          <p className="inline-flex items-center gap-2">
            Crafted with{" "}
            <Heart size={12} className="text-[#B78782] fill-[#B78782]" /> in
            Auckland
          </p>
        </div>
      </div>
    </footer>
  );
}
